import { render, staticRenderFns } from "./Maximixar.vue?vue&type=template&id=617054b6&scoped=true"
import script from "./Maximixar.vue?vue&type=script&lang=js"
export * from "./Maximixar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "617054b6",
  null
  
)

export default component.exports